<script setup>
import { computed } from 'vue'
import { useStore } from '@composables/use-store'
import Logo from '@components/logo'

const store = useStore()

const isMenuOpen = computed(() => store.state.appearance.isMainMenuOpen)

function toggleMenu() {
    store.dispatch('appearance/toggleMainMenu')
}

function closeMainMenu() {
    store.dispatch('appearance/closeMainMenu')
}
</script>

<template>
    <div class="menu-bar">
        <div
            v-click-outside="closeMainMenu"
            class="menu-button"
            @click="toggleMenu"
        >
            <span :class="['button-line', { active: isMenuOpen }]" />
        </div>

        <Logo :has-margin="false" />
        <BaseLink
            class="title"
            :to="{ name: 'search' }"
            aria-label="Go to Search Page"
        >
            <BaseIcon
                class="search-icon"
                name="search"
            />
        </BaseLink>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

// `position` is deliberately absent: layouts/main-layout.vue passes this component a `menu-bar` class of
// its own and makes it `position: sticky`, which is what the page actually renders.
.menu-bar {
    z-index: $layer-dropdown-z-index;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: $size-menu-bar-height;
    padding: gutter();
    text-align: center;
}

.button-line {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 2px;
    vertical-align: middle;
    background: $c-razzmatazz;

    &::before {
        position: absolute;
        top: -5px;
        left: 0;
        width: 16px;
        height: 2px;
        content: '';
        background: $c-razzmatazz;
    }

    &::after {
        position: absolute;
        top: 5px;
        left: 0;
        width: 16px;
        height: 2px;
        content: '';
        background: $c-razzmatazz;
    }

    &.active {
        background: transparent;

        &::before {
            top: 0;
            transform: rotate(45deg);
        }

        &::after {
            top: 0;
            transform: rotate(-45deg);
        }
    }
}

.title {
    margin: 0;
    font-size: 16px;
    font-weight: 900;
    line-height: $size-menu-bar-height - gutter() * 2;
    vertical-align: middle;
    color: $c-white;
}

.search-icon {
    position: absolute;
    top: 50%;
    right: 30px;
    width: 20px;
    height: 20px;
    box-shadow: 0 12px 24px 0 rgba(16, 17, 24, 0.27);
    fill: $c-grey-abbey;
    transform: translateY(-50%);
}

@media (min-width: $desktop) {
    .menu-bar {
        display: none;
    }
}
</style>
